import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { RootState } from "../store";
import { serverURL } from "../../config/backend";

/**
 * RTK Query foundation for server-state caching. Extend with endpoint slices
 * (opportunities, overview browse, configuration lists) incrementally.
 */
export const baseApi = createApi({
  reducerPath: "careproApi",
  baseQuery: fetchBaseQuery({
    baseUrl: serverURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  tagTypes: ["Opportunities", "UserContext", "Configuration"],
  endpoints: () => ({}),
});
